import Nullstack from 'nullstack';
export default function IconGenderGenderless({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-genderless",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
  }), "   ", Nullstack.element("path", {
    d: "M12 10v-7"
  }), "   ", Nullstack.element("path", {
    d: "M7 15h10"
  }), " ");
}